export default [ { name:"Clash",
    children:[ { name:"Archer Queen",
        children:[ { name:"archer_queen_die_01.ogg" },
          { name:"archer_queen_invis_01.ogg" } ] },
      { name:"Bowler",
        children:[ { name:"bowl_atk_01.ogg" },
          { name:"bowl_atk_02.ogg" },
          { name:"bowl_atk_03.ogg" },
          { name:"bowl_atk_04.ogg" },
          { name:"bowler_deploy_vo_01.ogg" },
          { name:"bowler_throw_02v3.ogg" } ] },
      { name:"Hog Rider",
        children:[ { name:"hogrider_deploy_end_01.ogg" },
          { name:"hr_emote_01_dl.ogg" } ] },
      { name:"King",
        children:[ { name:"king_congrats_01.ogg" },
          { name:"king_congrats_02.ogg" },
          { name:"king_congrats_03.ogg" },
          { name:"king_congrats_04.ogg" },
          { name:"king_crying_01.ogg" },
          { name:"king_crying_01_dl.ogg" },
          { name:"king_crying_02.ogg" },
          { name:"king_crying_03.ogg" },
          { name:"king_crying_04.ogg" },
          { name:"king_happy_01.ogg" },
          { name:"king_happy_01_dl.ogg" },
          { name:"king_happy_02.ogg" },
          { name:"king_happy_03.ogg" },
          { name:"king_happy_04.ogg" },
          { name:"king_laughter_01.ogg" },
          { name:"king_laughter_01_dl.ogg" },
          { name:"king_laughter_02.ogg" },
          { name:"king_laughter_03.ogg" },
          { name:"king_laughter_04.ogg" },
          { name:"king_mad_01.ogg" },
          { name:"king_mad_01_dl.ogg" },
          { name:"king_mad_02.ogg" },
          { name:"king_mad_03.ogg" },
          { name:"king_mad_04.ogg" },
          { name:"king_tower_gone_01.ogg" },
          { name:"king_tower_gone_02.ogg" },
          { name:"king_tower_gone_03.ogg" },
          { name:"king_tower_gone_04.ogg" },
          { name:"king_tower_gone_05.ogg" },
          { name:"king_tower_gone_06.ogg" },
          { name:"king_tower_gone_07.ogg" },
          { name:"king_tut_first_vo_01.ogg" },
          { name:"king_tut_second_vo_01.ogg" } ] } ] },
  { name:"Mario",
    children:[ { name:"Boo",
        children:[ { name:"00007 - WAV_7_GUESS_BNK_VO_PC08.ogg" },
          { name:"00012 - WAV_12_GUESS_BNK_VO_PC08.ogg" },
          { name:"00014 - WAV_14_GUESS_BNK_VO_PC08.ogg" },
          { name:"00015 - WAV_15_GUESS_BNK_VO_PC08.ogg" },
          { name:"00016 - WAV_16_GUESS_BNK_VO_PC08.ogg" },
          { name:"00017 - WAV_17_GUESS_BNK_VO_PC08.ogg" },
          { name:"00018 - WAV_18_GUESS_BNK_VO_PC08.ogg" },
          { name:"00022 - WAV_22_GUESS_BNK_VO_PC08.ogg" },
          { name:"00023 - WAV_23_GUESS_BNK_VO_PC08.ogg" },
          { name:"00024 - WAV_24_GUESS_BNK_VO_PC08.ogg" } ] },
      { name:"Daisy",
        children:[ { name:"00013 - WAV_13_GUESS_BNK_VO_PC04.ogg" },
          { name:"00014 - WAV_14_GUESS_BNK_VO_PC04.ogg" },
          { name:"00023 - WAV_23_GUESS_BNK_VO_PC04.ogg" },
          { name:"00024 - WAV_24_GUESS_BNK_VO_PC04.ogg" },
          { name:"00026 - WAV_26_GUESS_BNK_VO_PC04.ogg" },
          { name:"00028 - WAV_28_GUESS_BNK_VO_PC04.ogg" },
          { name:"00034 - WAV_34_GUESS_BNK_VO_PC04.ogg" } ] },
      { name:"Luigi",
        children:[ { name:"00013 - WAV_13_GUESS_BNK_VO_PC02.ogg" },
          { name:"00018 - WAV_18_GUESS_BNK_VO_PC02.ogg" },
          { name:"00024 - WAV_24_GUESS_BNK_VO_PC02.ogg" },
          { name:"00025 - WAV_25_GUESS_BNK_VO_PC02.ogg" },
          { name:"00037 - WAV_37_GUESS_BNK_VO_PC02.ogg" } ] },
      { name:"Mario",
        children:[ { name:"0x1A360.ogg" },
          { name:"0x2B140.ogg" },
          { name:"0x302E0.ogg" },
          { name:"0x3B060.ogg" },
          { name:"0x41F80.ogg" },
          { name:"0x6F2CA0.ogg" },
          { name:"0x6F75E0.ogg" },
          { name:"0x6FC120.ogg" } ] },
      { name:"Peach",
        children:[ { name:"00009 - WAV_9_GUESS_BNK_VO_PC03.ogg" },
          { name:"00013 - WAV_13_GUESS_BNK_VO_PC03.ogg" },
          { name:"00015 - WAV_15_GUESS_BNK_VO_PC03.ogg" },
          { name:"00016 - WAV_16_GUESS_BNK_VO_PC03.ogg" },
          { name:"00017 - WAV_17_GUESS_BNK_VO_PC03.ogg" },
          { name:"00020 - WAV_20_GUESS_BNK_VO_PC03.ogg" },
          { name:"00021 - WAV_21_GUESS_BNK_VO_PC03.ogg" },
          { name:"00022 - WAV_22_GUESS_BNK_VO_PC03.ogg" },
          { name:"00023 - WAV_23_GUESS_BNK_VO_PC03.ogg" } ] },
      { name:"Toad",
        children:[ { name:"00000 - WAV_0_GUESS_WSD_VO_GUIDE_GREETING_001.ogg" },
          { name:"00002 - WAV_2_GUESS_WSD_VO_GUIDE_GREETING_003.ogg" },
          { name:"00011 - WAV_11_GUESS_WSD_VO_GUIDE_SUCCESS.ogg" },
          { name:"00012 - WAV_12_GUESS_BNK_VO_PC09.ogg" },
          { name:"00012 - WAV_12_GUESS_WSD_VO_GUIDE_FAIL.ogg" },
          { name:"00014 - WAV_14_GUESS_BNK_VO_PC09.ogg" },
          { name:"00015 - WAV_15_GUESS_BNK_VO_PC09.ogg" },
          { name:"00016 - WAV_16_GUESS_BNK_VO_PC09.ogg" },
          { name:"00019 - WAV_19_GUESS_BNK_VO_PC09.ogg" },
          { name:"00022 - WAV_22_GUESS_BNK_VO_PC09.ogg" },
          { name:"00023 - WAV_23_GUESS_BNK_VO_PC09.ogg" },
          { name:"00026 - WAV_26_GUESS_BNK_VO_PC09.ogg" },
          { name:"00035 - WAV_35_GUESS_BNK_VO_PC09.ogg" } ] },
      { name:"Waluigi",
        children:[ { name:"00009 - WAV_9_GUESS_BNK_VO_PC06.ogg" },
          { name:"00014 - WAV_14_GUESS_BNK_VO_PC06.ogg" },
          { name:"00015 - WAV_15_GUESS_BNK_VO_PC06.ogg" },
          { name:"00016 - WAV_16_GUESS_BNK_VO_PC06.ogg" },
          { name:"00017 - WAV_17_GUESS_BNK_VO_PC06.ogg" },
          { name:"00021 - WAV_21_GUESS_BNK_VO_PC06.ogg" },
          { name:"00025 - WAV_25_GUESS_BNK_VO_PC06.ogg" },
          { name:"00033 - WAV_33_GUESS_BNK_VO_PC06.ogg" } ] },
      { name:"Wario",
        children:[ { name:"00012 - WAV_12_GUESS_BNK_VO_PC05.ogg" },
          { name:"00013 - WAV_13_GUESS_BNK_VO_PC05.ogg" },
          { name:"00016 - WAV_16_GUESS_BNK_VO_PC05.ogg" },
          { name:"00019 - WAV_19_GUESS_BNK_VO_PC05.ogg" },
          { name:"00024 - WAV_24_GUESS_BNK_VO_PC05.ogg" },
          { name:"00025 - WAV_25_GUESS_BNK_VO_PC05.ogg" },
          { name:"00026 - WAV_26_GUESS_BNK_VO_PC05.ogg" },
          { name:"00027 - WAV_27_GUESS_BNK_VO_PC05.ogg" },
          { name:"00036 - WAV_36_GUESS_BNK_VO_PC05.ogg" } ] },
      { name:"Yoshi",
        children:[ { name:"00012 - WAV_12_GUESS_BNK_VO_PC07.ogg" },
          { name:"00018 - WAV_18_GUESS_BNK_VO_PC07.ogg" },
          { name:"00019 - WAV_19_GUESS_BNK_VO_PC07.ogg" },
          { name:"00020 - WAV_20_GUESS_BNK_VO_PC07.ogg" },
          { name:"00021 - WAV_21_GUESS_BNK_VO_PC07.ogg" },
          { name:"00022 - WAV_22_GUESS_BNK_VO_PC07.ogg" },
          { name:"00026 - WAV_26_GUESS_BNK_VO_PC07.ogg" },
          { name:"00031 - WAV_31_GUESS_BNK_VO_PC07.ogg" } ] } ] } ]
